module.exports = __webpack_public_path__ + "img/about-header.e2615e17.jpg";